<template>
  <div>
    <div class="vehicle-build-top">
      <h4 class="text-center mb-0">{{ vehicleName }}</h4>
      <div class="text-center">
        <img
          :class="{ invisible: !selectedInteriorLabel || !selectedExteriorLabel }"
          :alt="vehicleName"
          :src="colorizedVehicleImage || require('@/assets/vehicle-fallback.png')"
        />
      </div>
    </div>
    <div v-if="showBuildDetails" data-test="buildDetails" class="pb-4">
      <div class="row">
        <div class="col-5">
          <h5>{{ $t('message.buildAndPrice.vehicle.buildDetails') }}</h5>
        </div>
        <div class="col-7 text-right">
          <mobialis-button class="py-1 change-model" width="w-auto" variant="link" @click="changeModel">
            {{ $t('message.buildAndPrice.vehicle.changeModel') }}
          </mobialis-button>
        </div>
      </div>
      <hr class="mt-1" />
      <div>
        <p class="option-name mt-0 mb-1">{{ $t('message.buildAndPrice.vehicle.driveTrainAndTransmission') }}</p>
        <p class="option-value mt-0 mb-3 pb-1">{{ driveTrainAndTransmission }}</p>
      </div>
      <div v-for="option in options" :key="option.name">
        <p class="option-name mt-0 mb-1">{{ option.name }}</p>
        <p class="option-value mt-0 mb-3 pb-1">{{ option.value }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'VehicleBuild',
  components: {},
  props: {
    showBuildDetails: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      vehicleName: 'buildAndPrice/vehicleName',
      colorizedVehicleImage: 'buildAndPrice/colorizedVehicleImage',
      selectedTrim: 'buildAndPrice/selectedTrim',
    }),
    ...mapState('buildAndPrice', ['selectedOptions']),
    selectedInteriorLabel() {
      return this.selectedOptions.interiorColor ? this.selectedOptions.interiorColor.label : null;
    },
    selectedExteriorLabel() {
      return this.selectedOptions.exteriorColor ? this.selectedOptions.exteriorColor.label : null;
    },
    options() {
      return [
        {
          name: this.$t('message.buildAndPrice.vehicle.exterior'),
          value: this.selectedExteriorLabel,
        },
        {
          name: this.$t('message.buildAndPrice.vehicle.interior'),
          value: this.selectedInteriorLabel,
        },
      ];
    },
    driveTrainAndTransmission() {
      return `${this.$t(`message.buildAndPrice.transmissionShort.${this.selectedTrim.vehicle.transmission}`)} ${
        this.selectedTrim.vehicle.drivetrain
      }`;
    },
  },
  methods: {
    changeModel() {
      this.$router.push({ path: 'model-select' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

h5 {
  font-size: 18px;
  line-height: 22px;
}

.change-model {
  line-height: 20px;
  padding: 5px 15px;
}

.option-name {
  font-size: 12px;
  line-height: 18px;
}

.option-value {
  font-size: 14px;
  line-height: 18px;
  color: #19222b;
  font-weight: 700;
}

.vehicle-build-top {
  max-width: 350px;
  margin: 0 auto;
  img {
    max-width: 100%;
  }
}

/* Mobile only*/
@media only screen and (max-width: $breakpoint-mobile) {
  .change-model {
    font-size: 14px;
    line-height: 16px;
    padding: 0 10px;
  }
}
</style>
